<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!atualizacoesInfoRisco || !atualizacoesInfoRisco.length">
      Não foram encontradas atualizações com os filtros informados.
    </div>
  
    <div *ngIf="atualizacoesInfoRisco && atualizacoesInfoRisco.length">
  
      <bn-paginacao [total]="atributosPaginacao.count"
        [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
        [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
  
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th *ngIf="!ehAgenteFinanceiro" id="col-agente" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'cnpjAgenteFinanceiro'"
                    [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-id-operacao-externo" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'idOperacaoAgente'"
                    [nomeAtributoExibicao]="'Id. externo operação'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-sistema-contrato" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'contratoRepasse'" 
                      [nomeAtributoExibicao]="'Sist./Contrato'"(aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>              
                <th id="col-status" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'statusProtocolo'" [nomeAtributoExibicao]="'Status'"
                    (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-data-envio" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEnvio'" [nomeAtributoExibicao]="'Janela'"
                    (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-risco-operacao" scope="col"  class="moeda">
                    <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'riscoOperacao'" [nomeAtributoExibicao]="'Risco/Perda Esperada'"
                      (aoClickar)="mudancaOrdenacao($event)">
                    </bn-ordenacao>
                  </th>
                <th id="col-liquidada" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'liquidada'" [nomeAtributoExibicao]="'Liquidada'"
                    (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let atualizacao of atualizacoesInfoRisco" id="pointer" [routerLink]="['/atualizacao-info-risco', atualizacao.id]">
                <td *ngIf="!ehAgenteFinanceiro" >{{ nomeAgenteFinanceiro(atualizacao.cnpjAgenteFinanceiro) }}</td>
                <td>{{ atualizacao.idOperacaoAgente }}</td>
                <td>{{ atualizacao.contratoCobranca ? atualizacao.sistemaCobranca + '/' + atualizacao.contratoCobranca : ''}}</td>
                <td>{{ obterLabelStatusProtocolo(atualizacao.statusProtocolo) }}</td>
                <td>{{ atualizacao.dataEnvio | date: 'yyyy'}}</td>
                <td>{{ atualizacao.riscoOperacao }}</td>
                <td>{{ atualizacao.liquidada == 'S' ? 'Sim' : 'Não'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </bn-paginacao>
    </div>
  </div>